module.exports = __webpack_public_path__ + "img/Maattekening dubbelwerkende cilinder met Topstangoog.266e2f7d.jpg";